import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _head from 'lodash/head';
import _size from 'lodash/size';

var Process = function Process() {
  var _this = this;

  _classCallCheck(this, Process);

  _defineProperty(this, "addHandler", function (callback) {
    _this.handlers.push(callback);

    return _this;
  });

  _defineProperty(this, "next", function (nextIndex) {
    return function () {
      if (nextIndex >= _size(_this.handlers)) {
        return undefined;
      }

      var nextHandler = _this.handlers[nextIndex];

      for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
        params[_key] = arguments[_key];
      }

      return nextHandler.apply(void 0, [_this.next(nextIndex + 1)].concat(params));
    };
  });

  _defineProperty(this, "run", function () {
    var firstHandler = _head(_this.handlers);

    if (!firstHandler) {
      return undefined;
    }

    var nextIndex = 1;

    for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      params[_key2] = arguments[_key2];
    }

    return firstHandler.apply(void 0, [_this.next(nextIndex)].concat(params));
  });

  this.handlers = [];
};

export default Process;